{
  "title": "Insect Plague",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level conjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "300 feet",
  "components": "V, S, M (a few grains of sugar, some kernels of grain, and a smear of fat)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Swarming, biting locusts fill a 20-foot-radius sphere centered on a point you choose within range. The sphere spreads around corners. The sphere remains for the duration, and its area is lightly obscured. The sphere’s area is difficult terrain.",
    "When the area appears, each creature in it must make a Constitution saving throw. A creature takes 4d10 piercing damage on a failed save, or half as much damage on a successful one. A creature must also make this saving throw when it enters the spell’s area for the first time on a turn or ends its turn there.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, the damage increases by 1d10 for each slot level above 5th."
  ],
  "spellLists": ["cleric", "druid", "sorcerer"]
}
